import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  BonusPeriodLiteModel,
  BonusPeriodModel,
  getBonusPeriodInput,
  getBonusPeriodsInput,
  getPreviousBonusPeriodEmployeesInput,
  PreviousBonusPeriodEmployeesModel,
} from './model';

export const bonusPeriodKeys = {
  index: (input?: getBonusPeriodsInput) => ['getBonusPeriods', input?.params],
  view: (input?: getBonusPeriodInput) => ['getBonusPeriod', input?.id],
};

const ENDPOINT = 'bonus-periods';

export function useGetBonusPeriods(
  input?: getBonusPeriodsInput,
  options?: UseQueryOptions<
    ExtendedApiResult<BonusPeriodLiteModel[]>,
    ApiError
  >,
): UseQueryResult<ExtendedApiResult<BonusPeriodLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? bonusPeriodKeys.index(input),
      () =>
        QueryFetchFunction({
          url: ENDPOINT,
          params: input?.params,
        }),
      options,
    ),
    BonusPeriodLiteModel,
  );
}

export function useGetBonusPeriod(
  input: getBonusPeriodInput,
  options?: UseQueryOptions<ApiResult<BonusPeriodModel>, ApiError>,
): UseQueryResult<ApiResult<BonusPeriodModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? bonusPeriodKeys.view(input),
      () =>
        QueryFetchFunction({
          url: `${ENDPOINT}/${input.id}`,
        }),
      options,
    ),
    BonusPeriodModel,
  );
}

export function useGetPreviousBonusPeriodEmployees(
  input?: getPreviousBonusPeriodEmployeesInput,
  options?: UseQueryOptions<
    ApiResult<PreviousBonusPeriodEmployeesModel[]>,
    ApiError
  >,
): UseQueryResult<ApiResult<PreviousBonusPeriodEmployeesModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['getPreviousBonusPeriodEmployees'],
      () =>
        QueryFetchFunction({
          url: `${ENDPOINT}/previous-bonus-period-employees`,
          params: input?.params,
        }),
      options,
    ),
    PreviousBonusPeriodEmployeesModel,
  );
}
